<div *ngIf="loading" class="container_loader">
	<div class="loader"></div>
</div>
<main>
	<app-solicitud [numCard]="this.dataRes.card?.numTarjeta" [nuevaSolicitud]="nuevaSolicitud"
		(closeModal)="nuevaSolicitud = $event"></app-solicitud>


	<section class="resumen">

		<app-aside [getData]="newCard" (loaded)="loaderOff($event)" (solici)="solicitud($event)"></app-aside>

		<div *ngIf="!noCards" class="resumen__content">

			<div class="title__section">
				<h2>Resumen medio de acceso</h2>
			</div>
			<div class="resumen__content__movimientos">

				<div class="resumen__content__movimientos__box">
					<div class="title">
						<h1>Fecha Último Saldo</h1>
					</div>
					<div class="movimientos">
						<div class="movimientos__item">
							<div class="ammount" *ngIf="resume?.listaTransacciones.length > 0;else noDate">
								<p>{{resume?.listaTransacciones[0].fecha_trx}}</p>
							</div>
							<ng-template #noDate>
								<div class="">
									<p>Fecha no informada</p>
								</div>
							</ng-template>
						</div>
					</div>
				</div>

				<div class="resumen__content__movimientos__box">
					<div class="title">
						<h1>Estado</h1>
					</div>
					<div class="movimientos">
						<div class="movimientos__item">
							<div class="ammount" *ngIf="resume?.estadoCuenta; else noResultEstado">
								<p>{{resume.estadoCuenta}}</p>
							</div>

							<ng-template #noResultEstado>
								<div class="">
									<p>Estado no informado</p>
								</div>
							</ng-template>
						</div>
					</div>

				</div>
				<div class="resumen__content__movimientos__box">
					<div class="title">
						<h1>Usos</h1>
					</div>
					<div class="movimientos">
						<ng-container *ngFor="let data of viajeList; let i = index">
							<div *ngIf="i <= 2" class="movimientos__item">
								<div class="date">
									<div class="day">
										<span>{{data.fecha_trx}}</span>
									</div>
									<div class="detail">
										<p>{{comproboTrx(data)}}</p>
									</div>
								</div>
								<div class="ammount">
									<p>Monto: ${{data.MONTO_DESCUENTO}}</p>
								</div>
							</div>
						</ng-container>
						<div *ngIf="viajeList.length == 0" class="movimientos__item">
							<div class="detail">Este medio de acceso no tiene usos</div>
						</div>
					</div>
				</div>
				<div class="resumen__content__movimientos__box">
					<div class="title">
						<h1>Cargas</h1>
					</div>
					<div class="movimientos">
						<ng-container *ngFor="let data of cargaList; let i = index">
							<div *ngIf="i <= 2" class="movimientos__item">
								<div class="date">
									<div class="day">
										<span>{{data.fecha_trx}}</span>
									</div>
									<div class="detail">
										<p>{{comproboTrx(data)}}</p>
									</div>
								</div>
								<div class="ammount">
									<p>Monto: ${{data.MONTO_ABONO}}</p>
								</div>
							</div>
						</ng-container>
						<div *ngIf="cargaList?.length == 0" class="movimientos__item">
							<div class="detail">Este medio de acceso no tiene cargas</div>
						</div>

					</div>
				</div>
				<div class="resumen__content__movimientos__box">
					<div class="title">
						<h1>Saldo Disponible</h1>
					</div>
					<div class="movimientos">
						<div class="movimientos__item text-right">
							<div *ngIf="resume.saldo != null" class="ammount">
								<p>$ {{resume.saldo}}</p>
							</div>
							<div *ngIf="resume.saldo == null" class="ammount">
								<p>$ 0</p>
							</div>

						</div>
					</div>
				</div>
			</div>
			<p *ngIf="errorMensaje" class="alert red">{{errorMensaje}}</p>
		</div>
	</section>
</main>